var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M.94 3.118h12M4.69 5.235l.188 5.647M6.94 5.235v5.647m2.25-5.647l-.187 5.647M2.44 3.118h9l-.323 8.52c-.029.76-.691 1.362-1.499 1.362H4.263c-.808 0-1.47-.602-1.5-1.361L2.44 3.118zm6.75 0v-.706C9.19 1.632 8.52 1 7.69 1h-1.5c-.828 0-1.5.632-1.5 1.412v.706h4.5z", stroke: "#545454", strokeLinecap: "round" })
  );
});